module.exports = __webpack_public_path__ + "static/media/stjerne_red-min.1875021f.png";